export type ColorMode = "light" | "dark";

export const COLOR_MODE_STORAGE_KEY = "sl:color-mode";
export const COLOR_MODE_ATTRIBUTE = "data-color-mode";

export function parseColorMode(value: string | null | undefined): ColorMode {
  return value === "dark" ? "dark" : "light";
}

export function createColorModeInitScript(): string {
  // Public survey pages render their own appearance theme. Skip the cached
  // platform preference there so visitors don't see a one-frame flash in the
  // visitor's color mode before React mounts and applies the survey's theme.
  return `(function(){try{if(location.pathname.indexOf("/survey/")===0)return;var k=${JSON.stringify(COLOR_MODE_STORAGE_KEY)};var a=${JSON.stringify(COLOR_MODE_ATTRIBUTE)};var m=window.localStorage.getItem(k);document.documentElement.setAttribute(a,m==="dark"?"dark":"light");}catch(_){}})();`;
}
